const urls = JSON.parse(process.env.REACT_APP_PROJECT_PORTAL_URL ?? '');

export default function getProjectPortalUrl(locale: string): string | undefined {
    return urls[locale];
}